import * as React from 'react';
import CalendarioAdmin from './CalendarioAdmin';
import '../../style/styleComponents/admin/DialogCalendarioAdmin.css';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { InfermiereInfo } from '../../models/InfermiereInfo';
import LoadingView from '../generics/LoadingView';
import { Button } from '@mui/material';
import LavoraDate from '../../utils/LavoraDate';


interface ComponentProps {
    open?: boolean;
    onClose?(open:boolean): void;
    dataSelected?(data:string, dataFormattata:string): void;
    infermiereSelezionato?: InfermiereInfo;
    nomeServizio?: string;
    primaDisponibilita?: Date;
    durata?: number;
    idServizio?: string;
}
export type Props = ComponentProps;


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));
  
  export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
  }
  

  function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;


    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }
  

  function DialogCalendarioAdmin(props: Props) {
    const [loading, setLoading] = React.useState(false);
    const [slotOrarioSelezionato, setSlotOrarioSelezionato] = React.useState<Date>();

    function onChangeOrario (slotOrario: Date, dataFormattata: string) {
      setSlotOrarioSelezionato(slotOrario);

      const dataString = LavoraDate.lavoraDataConMese(slotOrario) + ' ' + LavoraDate.prendeOrario(slotOrario);
      props.dataSelected!(dataString, dataFormattata);
    }

    const handleClose = () => {
      setSlotOrarioSelezionato(undefined);
      props.onClose!(false);
    };


    const handleAvantiButton = () => {
      setLoading(true);
      window.location.href = '/checkout'
      setLoading(false);
    }
  
    return (
      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={props.open!}
          className="dialog-calendario-infermiere"
        >

          <div className="titolo"> 
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
              <div>Scegli giorno e orario</div>
            </BootstrapDialogTitle>
          </div>

          <DialogContent dividers>
            <div className="recap">
              <div>
                <span className="label">Infermiere:</span> <span className="valore">{props.infermiereSelezionato?.nome}</span>
              </div>
              <div>
                <span className="label">Servizio:</span> <span className="valore">{props.nomeServizio}</span>
              </div>    
            </div>
            <div className="calendario">
                <CalendarioAdmin infermiereSelezionato = {props.infermiereSelezionato} 
                                    primaDisponibilita={props.primaDisponibilita} 
                                    durata={props.durata} 
                                    idServizio={props.idServizio}
                                    slotOrarioSelezionato={slotOrarioSelezionato}
                                    onChangeOrario={onChangeOrario}
                />
            </div>
          </DialogContent>
          
        </BootstrapDialog>

        <LoadingView
                visible={loading}
        />

      </div>
    );
  }
export default DialogCalendarioAdmin;